<template>
  <div
    class="try-see-pagearea"
    v-wechat-title="$route.meta.title = '试看'"
  >
    <camp-player
      @handle-play="handlePlay"
      :key="$route.query.t"
      :show-watermark="false"
      :show-custom-control-bar="true"
      :record-play-time="false"
    ></camp-player>

    <section class="list-wrapper" v-if="tryseeList.length" v-cloak>
      <trysee-catalog-list :lesson-is-playing="lessonPlaying" :seriesId="seriesId" :key="$route.query.t" :list="tryseeList"></trysee-catalog-list>
    </section>
  </div>
</template>

<script>
import {
  getLessonTrySee
} from '@/api/api';
import { isAndroid, isWechat } from '@/common/js/utils';
import { LESSON_TYPE } from '@/common/js/config';

import campPlayer from '@/components/campPlayer/campPlayer.vue';
import TryseeCatalogList from '@/components/TryseeCatalogList/TryseeCatalogList.vue';

export default {
  components: {
    campPlayer,
    TryseeCatalogList,
  },
  data() {
    return {
      tryseeList: [],
      player: null,
      // 课程ID
      seriesId: 0,
      LESSON_TYPE,

      played: false,
      playing: false,
      lastErrorCode: 0,

      lessonPlaying: false,
    };
  },
  filters: {
    durationStr(duration) {
      const minute = Math.floor(duration / 60) < 10 ? `0${Math.floor(duration / 60)}` : Math.floor(duration / 60);
      const seconds = duration % 60 < 10 ? `0${Math.floor(duration % 60)}` : Math.floor(duration % 60);
      return `${minute}:${seconds}`;
    }
  },
  created() {
    this.seriesId = +this.$route.query.sid;
    this.queryTrySeeData(this.seriesId);
  },
  methods: {
    // 获取播放列表
    queryTrySeeData(series_id) {
      getLessonTrySee(series_id).then((res) => {
        console.log('课程列表', res);
        this.tryseeList = res.items;
      });
    },
    setupVideoJs(videoUrls, width, height) {
      console.log('videoUrls', videoUrls);
      console.log('width', width);
      console.log('height', height);
      let sources = [];
      let preferLabel = '高清';
      videoUrls.forEach((_videoUrl, index) => {
        const { definition } = _videoUrl;
        let videoUrl = _videoUrl.src;

        // 线上协议替换
        if (videoUrl.indexOf('http:') > -1 && window.location.protocol === 'https:') {
          videoUrl = videoUrl.replace('http:', 'https:');
        }

        if (definition !== '') {
          let res = 0;
          let label = '';
          let type = '';
          const duration = _videoUrl.duration || 0;
          // eslint-disable-next-line default-case
          switch (definition) {
            case 5:
              label = '流畅';
              res = 640;
              break;
            case 4:
              label = '标清';
              res = 960;
              break;
            case 3:
              label = '高清';
              res = 1280;
              break;
            case 2:
              label = '超清';
              res = 1920;
              break;
            case 1:
              label = '原画';
              res = 2048;
              break;
          }

          if (videoUrl.indexOf('.m3u8') > 0) {
            type = 'application/x-mpegURL';
          } else if (videoUrl.indexOf('.mp4') > 0) {
            type = 'video/mp4';
          }

          console.log(`video type=${type}`);

          sources.unshift({
            src: videoUrl,
            label,
            res,
            type,
            duration
          });
        } else if (videoUrl.indexOf('f0.m3u8?') > 0) {
          sources.unshift({
            src: videoUrl,
            label: '原画',
            res: 360,
            type: 'application/x-mpegURL'
          });
        } else if (videoUrl.indexOf('f240.m3u8?') > 0) {
          sources.unshift({
            src: videoUrl,
            label: '超清',
            res: 1080,
            type: 'application/x-mpegURL'
          });
        } else if (videoUrl.indexOf('f230.m3u8?') > 0) {
          sources.unshift({
            src: videoUrl,
            label: '高清',
            res: 720,
            type: 'application/x-mpegURL'
          });
        } else if (videoUrl.indexOf('f220.m3u8?') > 0) {
          sources.unshift({
            src: videoUrl,
            label: '标清',
            res: 480,
            type: 'application/x-mpegURL'
          });
        } else if (videoUrl.indexOf('.f40.mp4') > 0 || videoUrl.indexOf('/40.mp4') > 0) {
          sources.unshift({
            src: videoUrl,
            label: '超清',
            res: 1080,
            type: 'video/mp4'
          });
        } else if (videoUrl.indexOf('f0.mp4?') > 0 || videoUrl.match(/\/\w+\.(mp4|m4v)\?/)) {
          sources.unshift({
            src: videoUrl,
            label: '原画',
            res: 360,
            type: 'video/mp4'
          });
        } else if (videoUrl.indexOf('.f30.mp4?') > 0 || videoUrl.indexOf('/30.mp4') > 0) {
          sources.unshift({
            src: videoUrl,
            label: '高清',
            res: 720,
            type: 'video/mp4'
          });
        } else if (videoUrl.indexOf('.f20.mp4?') > 0 || videoUrl.indexOf('/20.mp4') > 0) {
          sources.unshift({
            src: videoUrl,
            label: '标清',
            res: 480,
            type: 'video/mp4'
          });
        } else if (videoUrl.indexOf('f0.avi?') > 0) {
          sources.unshift({
            src: videoUrl,
            label: '原画',
            res: 360,
            type: 'video/avi'
          });
        } else if (videoUrl.indexOf('f230.avi?') > 0) {
          sources.unshift({
            src: videoUrl,
            label: '高清',
            res: 720,
            type: 'video/avi'
          });
        } else if (videoUrl.indexOf('f20.avi?') > 0) {
          sources.unshift({
            src: videoUrl,
            label: '标清',
            res: 480,
            type: 'video/avi'
          });
        } else if (videoUrl.indexOf('/20.avi') > 0) {
          sources.unshift({
            src: videoUrl,
            label: '标清',
            res: 470,
            type: 'video/avi'
          });
        }
      });

      const playerOptions = {
        controls: true,
        autoplay: false,
        preload: 'auto',
        width,
        height,
        playbackRates: [0.75, 1, 1.25, 1.5, 1.75, 2],
        plugins: {
          videoJsResolutionSwitcher: {
            default: 'high',
            dynamicLabel: true
          }
        }
      };

      if (isAndroid() && isWechat()) {
        console.log('[安卓微信] 去掉倍速播放');
        delete playerOptions.playbackRates;
      }
      console.log('+++++++++++++++++++++++++++++++++++++++++++');
      console.log('this.player', this.player);
      if (this.player) {
        this.player.dispose();
      }

      this.player = videojs(this.$refs.tryseeVideo, playerOptions, () => {
        preferLabel = '高清';

        this.player.updateSrc(sources);
        this.player.currentResolution(preferLabel);

        console.log('_sources', sources);
        // this.player.play()
        this.player.on('play', () => {
          console.log('video play');
          this.played = true;
        });
        this.player.on('playing', () => {
          console.log('video playing');
          this.playing = true;
        });
        this.player.on('pause', () => {
          console.log('video pause');
          this.playing = false;
        });
        this.player.on('resolutionchange', () => {
          console.log('[切换视频源]');
        });
        this.player.on('loadedmetadata', (event) => {
          console.log('video loadedmetadata');
          // if (played && !playing) {
          //     App.catchErr(function() {
          //         App.ctrls.lessonPlayCommon.restorePlayerTime();
          //     });
          // }
        });
        this.player.on('error', (event) => {
          console.log('[错误]');
          console.log(event);
        });
        this.player = (err) => {
          if (err === null) {
            return;
          }

          try {
            console.log(`err=${err}`);
            console.log(`code=${err.code}`);
            console.log(`message=${err.message}`);
          } catch (_err) {
            console.log(`_err=${_err}`);
          }

          // let newSources = [];
          if (err && err.code !== this.lastErrorCode) {
            this.lastErrorCode = err.code;
          }
          if (err && err.code === 4) {
            console.log('[播放错误]');
            if (!this.played) {
              const currentRes = this.player.currentResolution();
              let currentSrc = currentRes.src;
              if (!currentSrc && currentRes.sources && currentRes.sources.length == 1) currentSrc = currentRes.sources[0].src;
              if (currentSrc) {
                console.log(`[去掉出错播放源]${currentSrc}`);
              }
              const newSources = [];
              sources.forEach((source, i) => {
                if (currentSrc !== source.src) {
                  newSources.push(source);
                }
              });
              sources = newSources;
              if (!sources || sources.length === 0) {
                console.log('[没有可用视频源]');
              } else {
                this.player.updateSrc(sources);
              }
            } else {
              console.log('格式不支持');
            }
          } else {
            console.log('出错恢复');
          }
        };
      });
    },
    handlePlay(isPlaying) {
      this.lessonPlaying = isPlaying;
    }
  },
};
</script>

<style lang="stylus" scoped>
@import './../../common/stylus/variable.styl';
@import './../../common/stylus/mixin.styl';
.try-see-pagearea {
  width 100%
  min-height 100vh
  background #fff
}

.video-wrapper {
  width: 100%;
  height: 210px;
}

</style>
